import React from 'react';

import Inputs from '../../../Components/Inputs/Inputs';
import {useTranslation} from 'react-i18next';

const ForgotPassword = props => {
	const fieldDetail = JSON.parse(props.formData);
	console.log(fieldDetail);
    const {t} = useTranslation();
	return (
		<div className="form-login animated fadeIn">
            <div className="form-group mb-0" style={{position:'relative'}}>
                {/* <label htmlFor="" className=" secondary_color">{t('Email')}</label> */}
                <Inputs fieldName="email" formData={JSON.stringify(fieldDetail.email)} changed={props.changed}/>
                <span class="label-input100"> Email </span>
            </div>
            <div className="form-group"> 
                <button onClick={props.clicked} className="btn col-12 signInbtn mt-3 mt-sm-0" disabled={ props.forgotButtonDisabled }>Submit</button>
            </div>

                {
                    props.validationSuccess  ? 
                    <div className="form-group mb-0 animated slideInUp" role="alert" style={{textAlign:'center'}}><span className="badge badge-success"><i className="far fa-check-circle"></i> {props.validationSuccess} </span></div> : null
                }
                {
                    props.validationError  ? 
                    <div className="form-group mb-0 animated slideInUp" role="alert" style={{textAlign:'center'}}><span className="badge badge-danger"><i className="fas fa-exclamation-triangle"></i> {props.validationError} </span></div> : null
                }
            
        </div> 
	);
}

export default ForgotPassword;